import api from './api';

/**
 * 微信推送服务
 * 提供微信推送配置相关的API请求
 */

/**
 * 获取所有微信推送配置
 * @returns {Promise<Array>} - 推送配置列表
 */
export const getAllWxPusherConfigs = async () => {
  try {
    const response = await api.get('/wx-pusher/config');
    return response.data;
  } catch (error) {
    console.error('获取微信推送配置失败:', error);
    throw error;
  }
};

/**
 * 获取单个微信推送配置
 * @param {number} id - 配置ID
 * @returns {Promise<Object>} - 推送配置
 */
export const getWxPusherConfigById = async (id) => {
  try {
    const response = await api.get(`/wx-pusher/config/${id}`);
    return response.data;
  } catch (error) {
    console.error('获取微信推送配置详情失败:', error);
    throw error;
  }
};

/**
 * 添加微信推送配置
 * @param {Object} config - 配置信息
 * @returns {Promise<Object>} - 添加结果
 */
export const addWxPusherConfig = async (config) => {
  try {
    const response = await api.post('/wx-pusher/config', config);
    return response.data;
  } catch (error) {
    console.error('添加微信推送配置失败:', error);
    throw error;
  }
};

/**
 * 更新微信推送配置
 * @param {number} id - 配置ID
 * @param {Object} config - 配置信息
 * @returns {Promise<Object>} - 更新结果
 */
export const updateWxPusherConfig = async (id, config) => {
  try {
    const response = await api.put(`/wx-pusher/config/${id}`, config);
    return response.data;
  } catch (error) {
    console.error('更新微信推送配置失败:', error);
    throw error;
  }
};

/**
 * 删除微信推送配置
 * @param {number} id - 配置ID
 * @returns {Promise<Object>} - 删除结果
 */
export const deleteWxPusherConfig = async (id) => {
  try {
    const response = await api.delete(`/wx-pusher/config/${id}`);
    return response.data;
  } catch (error) {
    console.error('删除微信推送配置失败:', error);
    throw error;
  }
};

/**
 * 获取系统配置
 * @returns {Promise<Object>} - 系统配置
 */
export const getWxPusherSystemConfig = async () => {
  try {
    const response = await api.get('/wx-pusher/system-config');
    return response.data;
  } catch (error) {
    console.error('获取微信推送系统配置失败:', error);
    throw error;
  }
};

/**
 * 更新系统配置
 * @param {string} key - 配置键
 * @param {string} value - 配置值
 * @returns {Promise<Object>} - 更新结果
 */
export const updateWxPusherSystemConfig = async (key, value) => {
  try {
    const response = await api.put(`/wx-pusher/system-config/${key}`, { value });
    return response.data;
  } catch (error) {
    console.error('更新微信推送系统配置失败:', error);
    throw error;
  }
};

/**
 * 获取所有微信推送模板
 * @returns {Promise<Array>} - 模板列表
 */
export const getAllWxPusherTemplates = async () => {
  try {
    const response = await api.get('/wx-pusher/templates');
    return response.data;
  } catch (error) {
    console.error('获取微信推送模板列表失败:', error);
    throw error;
  }
};

/**
 * 获取单个微信推送模板
 * @param {string} templateKey - 模板标识符
 * @returns {Promise<Object>} - 模板信息
 */
export const getWxPusherTemplateByKey = async (templateKey) => {
  try {
    const response = await api.get(`/wx-pusher/templates/${templateKey}`);
    return response.data;
  } catch (error) {
    console.error(`获取微信推送模板(${templateKey})失败:`, error);
    throw error;
  }
};

/**
 * 更新微信推送模板
 * @param {string} templateKey - 模板标识符
 * @param {Object} templateData - 模板数据
 * @returns {Promise<Object>} - 更新结果
 */
export const updateWxPusherTemplate = async (templateKey, templateData) => {
  try {
    const response = await api.put(`/wx-pusher/templates/${templateKey}`, templateData);
    return response.data;
  } catch (error) {
    console.error(`更新微信推送模板(${templateKey})失败:`, error);
    throw error;
  }
};

/**
 * 重置微信推送模板为默认内容
 * @param {string} templateKey - 模板标识符
 * @returns {Promise<Object>} - 重置结果
 */
export const resetWxPusherTemplate = async (templateKey) => {
  try {
    const response = await api.post('/wx-pusher/templates/reset', { templateKey });
    return response.data;
  } catch (error) {
    console.error(`重置微信推送模板(${templateKey})失败:`, error);
    throw error;
  }
};

/**
 * 测试推送模板消息
 * @param {string} templateKey - 模板标识符
 * @param {number} configId - 推送配置ID
 * @param {Object} testData - 测试数据
 * @returns {Promise<Object>} - 测试结果
 */
export const testWxPusherTemplate = async (templateKey, configId, testData = {}) => {
  try {
    console.log('发送测试请求:', { templateKey, configId, testData });
    // 使用正确的API路径和参数名称
    const response = await api.post('/wx-pusher/templates/test', { 
      templateKey, 
      configId,
      testData
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      console.error(`响应错误:`, error.response.data);
    }
    console.error(`测试推送模板(${templateKey})失败:`, error);
    throw error;
  }
};
